import React from 'react';
import { Container } from 'reactstrap';
import queryString from 'query-string';
import {Link} from 'react-router-dom'
import imgA from './img/logo.png';

function Complete({location}){
    
    const {search} = location;
    const queryObj = queryString.parse(search);
    
    const {name} = queryObj;
    const positionCenter = {
        position:'absolute',
        top:'50%',
        transform:'translateY(-50%)'
    }
    const marginBottom = {
        marginBottom:'8rem'
    }

    
    return (
        <>
        <Container className="text-center com_wrap_mobile" style={positionCenter}>
            <div class="">
                <img className="" src={imgA}/>
                <h4 className="text-color mt-4 font-weight-bold" style={marginBottom}>{name}님 환영합니다! 회원가입 되었습니다.</h4>
                <div className="text-lightgray mb-4">
                    <span>지금 로그인해서</span><br />
                    <span>ABYS의 서비스를 이용해 보세요.</span>
                </div>
                <Link to="/login">
                    <button className="btn btn-primary btn-block p-10">로그인</button>
                </Link>
            </div>
        </Container>
        <Container className="text-center com_wrap_pc py-5">
            <div class="">
                <img className="" src={imgA}/>
                <h4 className="text-color mt-4 font-weight-bold" style={marginBottom}>{name}님 환영합니다! 회원가입 되었습니다.</h4>
                <div className="text-lightgray mb-4">
                    <span>지금 로그인해서</span><br />
                    <span>ABYS의 서비스를 이용해 보세요.</span>
                </div>
                <Link to="/login">
                    <button className="btn btn-primary btn-block p-10">로그인</button>
                </Link>
            </div>
        </Container>
        </>
    )

}


export default Complete;